export default __webpack_public_path__ + "feedback-960-cb03c43373918271b20e032116be4590.png";